// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"gtxAw","logoImage":"c_XZp","loaderTrack":"_1tEgy","loaderRail":"_36Oxx","slide":"_18iMg","loaderText":"vgIqq"};